import { render, staticRenderFns } from "./SellArchive.vue?vue&type=template&id=594843da&"
import script from "./SellArchive.vue?vue&type=script&lang=js&"
export * from "./SellArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports